import { Action } from '@ngrx/store';
import { GetCommentPayload, PostCommentPayload } from '@eview/core/domain/post/post';

export enum ECommentsActions {
    CreateComments = '[Post] Create Comments',
    CreateCommentsSuccess = '[Posts] Create Comments success',
    CreateCommentsFailure = '[Posts] Create Comments failure',
    GetCommentsData = '[Get] Get Comments',
    GetCommentsSuccess = '[Posts] Get Comments success',
    GetCommentsFailure = '[Posts] Get Comments failure',
    DeleteComment = '[Delete] Delete Comment',
    DeleteCommentSuccess = '[Delete] Delete Comments success',
    DeleteCommentFailure = '[Delete] Delete Comments failure',
}

export class CreateComments implements Action {
    readonly type = ECommentsActions.CreateComments;
    constructor(public payload: PostCommentPayload) { }
}

export class CreateCommentsSuccess implements Action {
    readonly type = ECommentsActions.CreateCommentsSuccess;
}

export class CreateCommentsFailure implements Action {
    readonly type = ECommentsActions.CreateCommentsFailure;
}

export class GetCommentsData implements Action {
    readonly type = ECommentsActions.GetCommentsData;
    constructor(public payload: GetCommentPayload) { }
}

export class GetCommentsSuccess implements Action {
    readonly type = ECommentsActions.GetCommentsSuccess;
    constructor(public payload: any) { }
}

export class GetCommentsFailure implements Action {
    readonly type = ECommentsActions.GetCommentsFailure;
}

export class DeleteComment implements Action {
    readonly type = ECommentsActions.DeleteComment;
    constructor(public payload: any) { }
}

export class DeleteCommentSuccess implements Action {
    readonly type = ECommentsActions.DeleteCommentSuccess;
}

export class DeleteCommentFailure implements Action {
    readonly type = ECommentsActions.DeleteCommentFailure;
}

export type CommentsActions = CreateComments | CreateCommentsSuccess | CreateCommentsFailure | GetCommentsData | GetCommentsSuccess | GetCommentsFailure | DeleteComment | DeleteCommentSuccess | DeleteCommentFailure;
